import { OnboardingCompanyProfile } from '__generated__/GQL';

const BIKER_ACTIVITY_CODE = '5320Z';

const isBiker = (
  activityType: OnboardingCompanyProfile['activityType'],
): boolean => activityType === BIKER_ACTIVITY_CODE;

export default isBiker;
